'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLinkedCamera = function ImageLinkedCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6' }),
    _react2.default.createElement('path', { d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
ImageLinkedCamera = (0, _pure2.default)(ImageLinkedCamera);
ImageLinkedCamera.displayName = 'ImageLinkedCamera';
ImageLinkedCamera.muiName = 'SvgIcon';

exports.default = ImageLinkedCamera;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/linked-camera.js
 ** module id = 2113
 ** module chunks = 0
 **/